export default "__VITE_ASSET__S_r8eFgh__"